import React from  'react';
import marked from 'marked';



export default class Doco extends React.Component {

    constructor(props) {
        super(props);
            this.state={
                markdown : null,
            };
        marked.setOptions({
            renderer: new marked.Renderer(),
            gfm: true,
            tables: true,
            breaks: false,
            pedantic: false,
            sanitize: false,
            smartLists: true,
            smartypants: false
        });
    }
    componentDidMount() {
      fetch("./userguide.md")
      .then(response => response.text()).then(text => {this.setState({markdown: text})});
    }
    _rendermarkdown(){
        if(!this.state.markdown){
            return (<div><h1>reticulating splines...</h1></div> )
        }else{
        var rawMarkup = marked(this.state.markdown || '', {sanitize: true});
        return(
            <section>
                <article dangerouslySetInnerHTML={{ __html: rawMarkup }}></article>
            </section>
            )
        }
    }

    render(){
      return(
        <div className="container">
            {this._rendermarkdown()}
        </div>
      )
    }
  }



// WEBPACK FOOTER //
// ./src/Doco/Doco.js